























import Vue, { PropType } from 'vue';
// import { Booth } from '@/modules/exhibitor/booth';

import {
  Booth,
} from 'mostra';

export default Vue.extend({
  name: 'GBrandBooth',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booths: {
      type: Array as PropType<Booth[]>,
      required: true,
    },
  },
});
